import React, { PropTypes } from 'react';
import classNames from 'classnames';

const classModifiers = {
    center: 'alert--center',
    fade: 'alert__animateFadeIn alert__animateFadeIn--run',
    slide: 'alert__animateSlideIn alert__animateSlideIn--run'
};

/**
 * Generic alert UI component
 */
const Alert = ({
    align,
    animation,
    className,
    message,
    style,
    onClose
}) => {
    const finalClassName = classNames(
        'alert',
        classModifiers[align],
        classModifiers[animation],
        className
    );
    return (
        <div className="alert__isOverlay" style={style}>
            <div className={finalClassName}>
                {message}
                <a onClick={onClose} className="alert_button--close icon-font-after icon-close-solid-after" />
            </div>
        </div>
    );
};

Alert.propTypes = {
    align: PropTypes.oneOf(['left', 'center']),
    animation: PropTypes.oneOf(['fade', 'slide']),
    className: PropTypes.string,
    message: PropTypes.string,
    style: PropTypes.object,
    onClose: PropTypes.func
};

export default Alert;



// WEBPACK FOOTER //
// ./app/common/alert/Alert.js